<template>
  <modal v-if="isOpen" class-name="service-info-modal" @close="$emit('close')">
    <template #header>
      <h3>
        Zulassung &amp; Lieferung
      </h3>
    </template>
    <template #body>
      <h4>Zulassung des Fahrzeugs durch TÜV Rheinland</h4>
      <p>Das Fahrzeug muss vor der Lieferung zugelassen werden. Ansonsten kann es nicht auf eigener Achse zu Ihnen nach Hause gefahren werden.</p>
      <p>Sie können Ihr Fahrzeug selbst zulassen. Gerne senden wir alle nötigen Papiere an das zuständige Straßenverkehrsamt, damit Sie Ihr Fahrzeug zulassen können.</p>
      <p>Alternativ können Sie unseren <strong>All-Inclusive Zulassungs-Service</strong> nutzen und wir lassen das Fahrzeug für Sie zu. Dieser Service kostet einmalig € {{ commercialBuyer ? order.car_info.online_offer_services.all_services_b2b.registration.standard : order.car_info.online_offer_services.all_services.registration.standard }} ,- und beinhaltet zwei Kennzeichenschilder, Feinstaubplakette sowie die Versandkosten & Amtsgebühren. Unser Partner im Bereich Zulassung ist der TÜV Rheinland.</p>
      <h4>Lieferung durch Car Controlling</h4>
      <p>Innerhalb deutschlands liefern wir Ihnen das Fahrzeug auf eigener Achse <strong>immer kostenlos</strong> bis vor die Haustür. Car Controlling ist unser Partner für die Lieferung Ihres Fahrzeugs.</p>
      <p>Sie können zwischen zwei Lieferoptionen wählen:</p>
      <ul>
        <li>
          <p><strong>Überführung auf eigener Achse (bis 3,5t): € 0 ,- Gratis Lieferung</strong></p>
          <p>Hinweis: Bei Überführung auf eigener Achse besteht eine Winterreifenpflicht bei winterlichen Straßenverhältnissen nach der Neuregelung der Straßenverkehrsordnung (StVO) seit dem 04.12.2010.</p>
          <p class="hint">Natürlich können Sie in unserem Online-Kauf auf Wunsch Winterreifen dazubuchen.</p>
        </li>
        <li>
          <p><strong>Überführung per Spedition (Fremdachse): ab € {{ commercialBuyer ? order.car_info.online_offer_services.all_services_b2b.delivery.transporter : order.car_info.online_offer_services.all_services.delivery.transporter }} ,-</strong></p>
          <p>Hinweis: Keine Winterreifenpflicht beim Transport per Spedition.</p>
        </li>
      </ul>
      <h4>Liefertermin</h4>
      <p>Den Liefertermin stimmen Sie mit unserem Partner Car Controlling ab. Wir liefern <strong>Montag bis Freitag von 08:00 bis 18:00 Uhr</strong> (noch vor Sonnenuntergang) und eine Lieferung am Samstag ist ebenfalls möglich. Wir richten uns natürlich nach Ihrem Terminkalender. </p>
      <p>Die Übernahme des Fahrzeugs wird protokolliert. Sie überprüfen das Fahrzeug gemeinsam mit dem Lieferanten. Dieser macht Fotos vom Fahrzeug und Sie erhalten ein Übernahmeprotokoll.</p>
      <p><a title="mehr erfahren" href="https://www.c-controlling.de/" target="_blank">Mehr über Car Controlling</a></p>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
  }
};
</script>

<style lang="scss" scoped>
.service-info-modal {
  h3 {
    color:$red;
    margin-bottom: .8em;

    @include breakpoint(desktop) {
      font-size: 28px;
    }
  }

  h4 {
    margin-bottom: .5em;
    position: relative;

    @include breakpoint(desktop) {
      font-size: 22px;
    }
  }

  p {
    margin-bottom: 1rem;

    @include breakpoint(desktop) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  a {
    display: inline-block;
    border: 1px solid #c0131b;
    color:#c0131b;
    text-decoration: none;
    text-align: center;
    line-height: 40px;
    padding: 10px 20px;
  }
}
</style>
